export default [
  {
    style: {
      marginTop: '130px'
    },
    title: true
  },
  {
    style: {
      marginTop: '50px'
    },
    row: 1
  },
  {
    style: {
      margin: '20px 0 40px'
    },
    row: 9
  },
  {
    type: 'custom',
    itemStyle: {
      width: '700px',
      height: '400px'
    }
  },
  {
    style: {
      margin: '20px 0 40px'
    },
    title: true
  },
  {
    style: {
      margin: '20px 0 40px'
    },
    row: 7
  }
];